/* eslint-disable no-inline-styles/no-inline-styles */
/* eslint-disable react/no-array-index-key */
import Marquee from 'react-fast-marquee';

import Image from 'molecules/Image';

import { hasArrayValues } from 'utils/array/arrays';

import type { TrustbarConfigProps } from 'components/Trustbar/config';
import type { FC } from 'react';

interface TrustbarMoleculeProps extends TrustbarConfigProps {
  isDark?: boolean;
}

const TrustbarMolecule: FC<TrustbarMoleculeProps> = props => {
  const { heading, trustBars, isDark } = props;

  return (
    <div className="flex flex-col gap-5 px-2.5">
      {heading && <div className="text-center font-semibold text-gray-500 text-overline-md">{heading}</div>}
      {hasArrayValues(trustBars) &&
        trustBars.map((trustBar, index) => (
          <div key={trustBar?.id} className="relative w-full">
            <div className="relative">
              <Marquee
                autoFill
                speed={20}
                direction={index % 2 === 0 ? 'left' : 'right'}
                gradient
                gradientColor={isDark ? '#101017' : '#f3fefe'}
                gradientWidth="120px"
              >
                {hasArrayValues(trustBar?.logos) &&
                  trustBar?.logos?.map((item, idx) => {
                    if (!item?.logo || !item?.logo.file?.url) {
                      return null;
                    }

                    return (
                      <div key={idx} className="mx-12 flex items-center justify-center overflow-hidden">
                        <Image
                          url={item?.logo?.file?.url || ''}
                          alt={item?.logo?.alt || item?.logo?.file?.alt || ''}
                          {...item?.logo?.file}
                          noFill
                          className="brightness-0 grayscale invert-[50%]"
                          style={{ maxHeight: '2rem', maxWidth: '120px' }}
                        />
                      </div>
                    );
                  })}
              </Marquee>
            </div>
          </div>
        ))}
    </div>
  );
};

export default TrustbarMolecule;
